"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = createVideo;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _VideoDialog = _interopRequireDefault(require("../VideoDialog"));

var _vue = _interopRequireDefault(require("vue"));

var currentMsg = null;

function defaultCallback(action) {
  if (!action) {
    currentMsg.reject();
  }

  currentMsg.resolve();
}

function createVideo(params) {
  var video = null;

  var VideoConstructor = _vue.default.extend(_VideoDialog.default);

  VideoConstructor.prototype.callback = defaultCallback;

  if (!video) {
    video = new VideoConstructor().$mount();
    document.body.appendChild(video.$el);
    document.documentElement.style.overflow = 'hidden';
  } // params: 暂时只传url


  var url = params.url,
      autoplay = params.autoplay,
      loop = params.loop;
  video.url = url;
  video.visible = true;
  video.autoplay = autoplay || false;
  video.loop = loop || false;
  return new _promise.default(function (resolve, reject) {
    currentMsg = {
      resolve,
      reject
    };
  });
}

;